import React, { useContext, useEffect, Fragment, useRef } from "react";
import VideoContext from "../../context/video/videoContext";
import UserContext from "../../context/user/userContext";
import VideoItem from "../layouts/VideoItem";
import Spinner from "../layouts/Spinner";
import "../../styles/fonts.css";
const FilterSearchBar = (props) => {
  const userContext = useContext(UserContext);
  const keyword = useRef("");
  const { filterVideos, clearFilter } = userContext;
  const onChange = () => {
    filterVideos(keyword.current.value, props.type);
  };
  useEffect(() => {
    return () => {
      clearFilter();
    };
    //eslint-disable-next-line
  }, []);
  return (
    <nav className='mb-2 bg-dark navbar navbar-dark'>
      <form className='col-12'>
        <input
          ref={keyword}
          className='form-control form-control-lg simplefont'
          onChange={onChange}
          type='text'
          placeholder='Filter By Title'
        />
      </form>
    </nav>
  );
};

const Videos = (props) => {
  let type = props.match.params.type;
  const query = props.match.params.query || "*";
  const videoContext = useContext(VideoContext);
  const userContext = useContext(UserContext);
  const { videos, getVideos, resource, getMore } = videoContext;
  useEffect(() => {
    window.scrollTo(0, 0);

    if (!userContext.videos && props.match.params.uid) {
      userContext.getUserResources({
        id: props.match.params.uid,
      });
    }
    if (!videos || resource) {
      getVideos({ q: query.split(" ") });
    }
    if (videos) {
      console.log(videos.academics);
    }
    //eslint-disable-next-line
  }, [query, type]);
  const addMore = () => {
    getVideos(query.split("+"));
  };
  return (
    <div className='container'>
      {videoContext.query && (
        <Fragment>
          <span className='badge badge-pill badge-secondary mr-2'>
            {videoContext.query.course}
          </span>
          <span className='badge badge-pill badge-secondary mr-2'>
            {videoContext.query.subject}
          </span>
          <span className='badge badge-pill badge-secondary mr-2'>
            {videoContext.query.branch}
          </span>
          <span className='badge badge-pill badge-secondary mr-2'>
            {videoContext.query.year && "year " + videoContext.query.year}
          </span>
        </Fragment>
      )}
      {userContext.videos && <FilterSearchBar type={type} />}
      {userContext.filter ? (
        userContext.filter.map((video) => (
          <VideoItem
            key={video.id}
            video={video}
            small='no'
            coll={video.coll}
          />
        ))
      ) : userContext.videos && type === "videos" ? (
        userContext.videos.map((video, i) => (
          <VideoItem key={i} video={video} small='no' coll={video.coll} />
        ))
      ) : userContext.notes && type === "notes" ? (
        userContext.notes.map((video) => (
          <VideoItem
            key={video.id}
            video={video}
            small='no'
            coll={video.coll}
          />
        ))
      ) : videos ? (
        <Fragment>
          {videos.academics && !props.match.params.id && (
            <h4 className='fontcool text-center border-bottom border-dark'>
              Academic Videos<i className='fas fa-caret-down'></i>
            </h4>
          )}
          {videos.academics &&
            videos.academics.map((video) => (
              <VideoItem
                key={video.id}
                video={video}
                small='no'
                type={type}
                coll={"acad"}
              />
            ))}
          {videos.extracurriculars && !props.match.params.id && (
            <h4 className='fontcool text-center border-bottom border-dark'>
              Extracurricular Videos<i className='fas fa-caret-down'></i>
            </h4>
          )}
          {videos.extracurriculars &&
            videos.extracurriculars.map((video) => (
              <VideoItem
                key={video.id}
                video={video}
                small='no'
                type={type}
                coll={"extra"}
              />
            ))}
          {videos.youtube && !props.match.params.id && (
            <Fragment>
              <h4 className='fontcool text-center border-bottom border-dark'>
                Youtube<i className='fas fa-caret-down'></i>
              </h4>
              {videos.youtube.map((video) => (
                <VideoItem
                  key={video.id}
                  video={video}
                  small='no'
                  type={type}
                  coll='youtube'
                />
              ))}
            </Fragment>
          )}
          {videos.suggestions &&
            props.match.params.id &&
            videos.suggestions.map((video) => (
              <VideoItem
                key={video.id}
                video={video}
                small='yes'
                type={type}
                coll={video.coll}
              />
            ))}
        </Fragment>
      ) : (
        <Spinner />
      )}
      {/*!props.match.params.id && !props.match.params.uid && (
        <button className='btn btn-link' onClick={addMore}>
          More Results...
        </button>
      )*/}
    </div>
  );
};

export default Videos;
